export default "__VITE_ASSET__BqttKWyh__"